import React from 'react';
import {Animated} from "react-animated-css";

import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
} from 'react-share';


import CompanyImg from '../../media/logo-francorosso@2x.png';
import Footer from "../Footer";

var CompanyName = 'Francorosso';
var CompanyLink = 'https://www.alpitour.it/francorosso?utm_source=morphcast&utm_medium=distribution&utm_campaign=ragioneemozione';
var shareUrl = window.location.origin + "/romantic-romantic.html";


class Result extends React.Component {
    render() {
        return (
            <div className="Res">
                <div className="ResultWrap RomanticRomanticWrap">


                    <div className="container-fluid d-flex flex-column">
                        <div className="row no-gutters">
                            <div className="col-md-4 col-xl-3 decision-left">
                                <Animated animationIn="fadeIn" animationInDuration={500}
                                          className="d-md-flex justify-content-end">

                                    <p className="h5">Con la <strong>RAGIONE</strong> hai scelto una vacanza all’insegna
                                        dell’amore e del romanticismo.</p>
                                </Animated>
                            </div>
                            <div className="col-md-7 decision-right">
                                <Animated animationIn="fadeIn" animationInDuration={500} className="decision-inner">

                                    <Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={200}>
                                        <p className="h3 mb-4">E INFATTI LA TUA RAGIONE... HA RAGIONE!</p>
                                    </Animated>
                                    <Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={400}>

                                        <h1>ROCK ‘N’ LOVE</h1>
                                    </Animated>
                                    <Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={600}>
                                        <p className="h4">Per scoprire qualcosa di nuovo, anche su te stesso, butti
                                            sempre il cuore oltre l’ostacolo. Che si tratti di escursioni
                                            indimenticabili, sport o destinazioni. Devi sempre arrivare un passo più in
                                            là. Anche di cha cha cha.</p>
                                    </Animated>

                                    <Animated animationIn="fadeInLeft" animationInDuration={500}
                                              animationInDelay={1000}>
                                        <a href={CompanyLink}><img className="logo-result" src={CompanyImg}
                                                                   alt={CompanyName}/></a>


                                        <a href={CompanyLink} className="btn btn-danger btn-lg">Scopri di più</a>
                                    </Animated>

                                </Animated>
                            </div>
                        </div>


                        <div className="share mt-md-auto text-md-right py-4">
                            <Animated animationIn="fadeInLeft" animationInDuration={500} animationInDelay={1200}>
                                <h5><span>CONDIVIDI IL RISULTATO</span> <FacebookShareButton
                                    url={shareUrl}><FacebookIcon size={40} round={true}/></FacebookShareButton>
                                    <TwitterShareButton url={shareUrl}><TwitterIcon size={40}
                                                                                    round={true}/></TwitterShareButton>
                                </h5>
                            </Animated>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Result;